import React from 'react';
import { Box, useTheme } from '@mui/material';
import { CenterLayout } from '@orgnc/core/components/primitives';
import { forwardArticleRef } from '@orgnc/core/lib/themes/templates/article';
import { useSiteSpecificComponents, useTemplateQuery } from '@orgnc/core/hooks';
import postDisqusCommentsQuery from '@/lib/queries/postDisqusCommentsQuery';
import GoogleAdTag from '@/components/GoogleAdTag';
import NnArticleTemplateContent from './NnArticleTemplateContent';
import { injectAds, renderAfterContent } from './shared/articleUtils';
import usePostExtraFields from '../../../utils/usePostExtraFields';

const NnArticleTemplate = forwardArticleRef((props, ref) => {
  const theme = useTheme();
  const { themeId } = useSiteSpecificComponents();

  const { data: postDisqusCommentsData } = useTemplateQuery(
    postDisqusCommentsQuery,
    props.post
  );
  const postExtraFields = usePostExtraFields(props.post);

  const extendedProps = {
    ...props,
    post: injectAds(props.post),
    postExtraFields,
  };

  const disqusOptions = postDisqusCommentsData?.post?.disqusOptions;

  return (
    <>
      <Box ref={ref} component="article">
        <CenterLayout
          maxWidth={`${theme.breakpoints.values.xl}${theme.breakpoints.unit}`}
        >
          <NnArticleTemplateContent
            {...extendedProps}
            sidebarContent={
              <GoogleAdTag
                zone="sidebar"
                sizes={[[300, 250]]}
                mapping={[
                  [
                    [1024, 768],
                    [
                      [300, 250],
                      [300, 600],
                    ],
                  ],
                ]}
              />
            }
            afterContentSlot={renderAfterContent(
              themeId,
              props.post.link || '',
              disqusOptions,
              props.post.title
            )}
          />
        </CenterLayout>
      </Box>
    </>
  );
});

export default NnArticleTemplate;
